import { createModuleContext } from '@rebuild/utils/moduleContext';
import i18n from '@/assets/js/i18n';

const MODULE_NAME = 'quarterly_performance';

function buildBaseCtx() {
	return {
		getPerformanceContentTitle: prop => {
			if (prop === 't1') {
				return i18n.t('enterprise.page-version');
			}
			if (prop === 't2') {
				return i18n.t('enterprise.earnings-library');
			}
		}
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext };
